import React, { useEffect, useState } from 'react';

const FastTypingText = ({ text }) => {
  const [displayText, setDisplayText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const typingSpeed = 10; // Reduced from 50 to 10 for much faster typing

    const typingInterval = setInterval(() => {
      setCurrentIndex(prevIndex => prevIndex + 1);
    }, typingSpeed);

    return () => clearInterval(typingInterval);
  }, []);

  useEffect(() => {
    const processedText = text.slice(0, currentIndex);
    setDisplayText(processedText);
  }, [text, currentIndex]);

  const displayLines = displayText.split('\n');
  const textLines = text.split('\n');
  const minLinesLength = Math.min(displayLines.length, textLines.length);

  return (
    <div id="message" style={{ whiteSpace: 'pre-line', textAlign: 'left' }}>
      {Array.from({ length: minLinesLength }, (_, index) => (
        <React.Fragment key={index}>
          {textLines[index].slice(0, displayLines[index].length)}
          {index !== minLinesLength - 1 && <br />} {/* Render line break if not the last line */}
        </React.Fragment>
      ))}
    </div>
  );
};

export default FastTypingText;
